//全局制作部门
export default {
  data () {
    return {
      department:{
        0:'全部',
        23:'制作一部',
        24:'制作二部',
        25:'制作三部',
        26:'制作四部',
        28:'制作五部',
      }, //制作部数据

      c_department:[0], // 默认全部区域
    }
  },
  methods:{

    onDepartmentChang (index) {
      this.c_department = []
      this.c_department.push(index)
    },

    findDepartmentID (name) { //查找地区id
      let department = this.department
      for ( var key in department) {
        if ( department[key] == name ) {
          return key
        }
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/mixins/groupChange.js